export const partnerData = [
  { title: "", something: "" },
  { more: "", day: "" },
  {
    contLeftTitle: `Vaillant Boilers`,
    contLeftText: `Vaillant has been setting the standards in the heating market, creating products that have revolutionised the industry, from water heaters in the early 1900’s, to pioneering the ‘combi’ boiler over 35 years ago.`,
    leftImgUrl: `https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_580/v1643110995/AquaHeat/new%20images/ecotec-range-1112637-format-flex-height_345_retina_amzd6f.webp`,
  },
  {
    contRightTitle: "Ideal Boilers",
    contRightText: `Today, Ideal remains at the forefront of the domestic and commercial heating markets, leading the industry in setting new standards and challenging technological boundaries.`,
    rightImgUrl: `https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_580/v1643111135/AquaHeat/new%20images/ideal_oukwxi.webp`,
  },
];
